import "@github/relative-time-element";
import { Elm } from "./elm/Main.elm";

const browserTimeZone =
    Intl.DateTimeFormat().resolvedOptions().timeZone;

Elm.Main.init({
    node: document.getElementById("app"),
    flags: {
        timeZone: browserTimeZone
    }
});
